import CustomFactoryClient from "../../../../components/CustomFactoryClient/CustomFactoryClient";
import CustomFormFactory from "../../../../components/CustomFormFactory/CustomFormFactory";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { restUseCase } from "../../../../usecases/rest";
import FormUtils from "../../../../utils/classUtils/FormUtils";
import withRouter from "../../../../utils/withRouter";
import ManageClientFormPresenter from "./ManageClientFormPresenter";

class ManageClientFormPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, modalState: false };
    this.presenter = new ManageClientFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase()
    );
    this.fieldsToExclude = [
      "id",
      "createdAt",
      "updatedAt",
      "acl",
      // "code",
      // "clientCode",
      // "isShowOutSide",
    ];
  }

  getCollectionName() {
    return "affiliates";
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      write: [user.id, "role:admin", "*"],
    };
  }

  render() {
    const { fields, sections } = this.getSchema(this.getCollectionName());
    const { object } = this.state;

    return (
      <PageContainer title="Create Client Information">
        <form onSubmit={this.onSubmitForm.bind(this)}>
          <CustomFactoryClient
            schema={this.transformFieldsToSections({ fields, sections })}
            object={object}
            fieldsToExlude={this.fieldsToExclude}
            onChange={this.onChange.bind(this)}
            navigateBack={this.navigateBack.bind(this)}
          />
        </form>
      </PageContainer>
    );
  }
}

export default withRouter(ManageClientFormPage);
